import { getVersionForClone } from '@qr-front/ui/utils'
import { atom } from 'jotai'

import {
	primaryColorAtom,
	secondaryColorAtom,
} from '@/content-from-sections/client'

import { isDemoModeAtom } from '../../../generatorState'

export const APP_DEMO_PRIMARY_COLOR = getVersionForClone({
	base: {
		primary: '#F5BCA1',
		secondary: '#FFFFFF',
	},
	clone1: {
		primary: '#809DF4',
		secondary: '#FFFFFF',
	},
})

export const appPrimaryColorAtom = atom((get) =>
	get(isDemoModeAtom) ? APP_DEMO_PRIMARY_COLOR.primary : get(primaryColorAtom),
)

export const appSecondaryColorAtom = atom((get) =>
	get(isDemoModeAtom)
		? APP_DEMO_PRIMARY_COLOR.secondary
		: get(secondaryColorAtom),
)
